/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type ContactDealerInlineForm_viewer$ref = any;
type PdpRespDealerDetailsStats_viewer$ref = any;
type PdpSharedSellerTabsVariant_viewer$ref = any;
export type PdpRespDealerDetails_viewer$ref = any;
export type PdpRespDealerDetails_viewer = {
    readonly isMessageCenterEnabled: boolean | null;
    readonly isReviewsEnabled: boolean | null;
    readonly isEmbeddedMakeOfferTestDisabled: boolean | null;
    readonly " $fragmentRefs": PdpRespDealerDetailsStats_viewer$ref & ContactDealerInlineForm_viewer$ref & PdpSharedSellerTabsVariant_viewer$ref;
    readonly " $refType": PdpRespDealerDetails_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespDealerDetails_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isMessageCenterEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "MESSAGE_CENTER"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
        },
        {
            "kind": "ScalarField",
            "alias": "isReviewsEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "ORDER_FEEDBACK"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"ORDER_FEEDBACK\")"
        },
        {
            "kind": "ScalarField",
            "alias": "isEmbeddedMakeOfferTestDisabled",
            "name": "isEnabled",
            "args": [
                {
                    "kind": "Literal",
                    "name": "key",
                    "value": "disablePdpEmbeddedMakeOfferTest"
                }
            ],
            "storageKey": "isEnabled(key:\"disablePdpEmbeddedMakeOfferTest\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespDealerDetailsStats_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "ContactDealerInlineForm_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedSellerTabsVariant_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'ef92298cee7c833a71c03dff2fd3a84a';
export default node;
